import React, { useEffect, useState } from "react"
import { AppLayout } from "@kit/design/app-layout"
import { useMediaBreakpoint } from "@kit/design/use-media-breakpoint"
import { AppNavigation } from "app/navigation/app-navigation"
import { useFocusMode } from "hooks/use-focus-mode"
import { LayoutBanners } from "./layout-banners"

export function VerticalNavLayout({ layoutConfig, children }) {
  const isMobile = !useMediaBreakpoint("md")
  const [mobileNavExpanded, setMobileNavExpanded] = useState(false)
  const inFocusMode = useFocusMode(state => state.inFocusMode)

  // useCollapsibleSidebar fires onCollapsedChange(false) on desktop mount (sidebar
  // not collapsed), leaving mobileNavExpanded stale as true. When we resize to mobile,
  // startCollapsed force-collapses the nav without firing onCollapsedChange, so the
  // stale true would keep frame styling visible on collapsed mobile nav. Reset on entry.
  useEffect(() => {
    if (isMobile) setMobileNavExpanded(false)
  }, [isMobile])

  return (
    <AppLayout>
      <AppNavigation
        mobile={isMobile}
        hidden={inFocusMode}
        onCollapsedChange={collapsed => setMobileNavExpanded(!collapsed)}
      />
      <AppLayout.Content
        className="flex flex-col"
        mobile={isMobile}
        mobileNavExpanded={isMobile && mobileNavExpanded}
        navHidden={inFocusMode}
      >
        <LayoutBanners layoutConfig={layoutConfig} />
        <div className="flex-1 min-h-0" style={{ "--vertical-nav": 1 }}>
          {children}
        </div>
      </AppLayout.Content>
    </AppLayout>
  )
}
